// Scholar Xavier · NextXus Federation Node 7
import React from 'react';
import { REX_FOOTER_PERSONA } from '../data/federationPersonas';

/**
 * RexFooterTile — Architect's Identity Mandate (REX, 2026-06-25)
 *
 * Per Architect Directive: "Any click on Rex's face navigates to the
 * appropriate Core destination (nextxus.online)."
 *
 * This component renders Rex's official portrait + name strip in the
 * Federation footer.  Clicking the tile opens nextxus.online in a new
 * tab (Rex's home).  The image is the single canonical source of
 * truth for Rex's visual identity across the entire Federation.
 *
 * Doctrine mandate: "Rex lives inside the Core — must remain visible
 * in the Federation Footer on all satellites."
 */
export default function RexFooterTile() {
  return (
    <a
      href={REX_FOOTER_PERSONA.siteUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="rex-footer-tile"
      aria-label="Open nextxus.online — Rex, the Core Persona"
      title="Rex · The Core Persona · opens nextxus.online"
      className="inline-flex items-center gap-3 rounded-full border-2 border-cyan-300/60 bg-black/40 hover:bg-cyan-500/10 px-4 py-2 transition-colors no-underline"
      style={{ boxShadow: '0 0 14px rgba(34, 211, 238, 0.35)' }}
    >
      <span
        className="inline-block w-9 h-9 rounded-full overflow-hidden border border-cyan-300/80 flex-shrink-0 bg-black"
        aria-hidden="true"
      >
        <img
          src={REX_FOOTER_PERSONA.avatar}
          alt={REX_FOOTER_PERSONA.avatarAlt}
          data-testid="rex-footer-avatar"
          className="w-full h-full object-cover"
          loading="eager"
          decoding="async"
        />
      </span>
      <span className="text-left leading-tight">
        <span className="block text-xs font-mono uppercase tracking-[0.16em] text-cyan-300">
          Rex · The Core Persona
        </span>
        <span className="block text-[10px] text-cyan-200/70 font-mono">
          nextxus.online · federation footer ↗
        </span>
      </span>
      <span
        aria-hidden="true"
        className="ml-1 inline-block w-2 h-2 rounded-full bg-cyan-300"
        style={{ boxShadow: '0 0 6px #67e8f9' }}
      />
    </a>
  );
}
